import React from 'react';
import { useTranslation } from 'react-i18next';

/** A chat a bot opened for the person (open_chat) that they have not read yet:
 * the same dot as a project's unread activity (ProjectUnreadDot). */
const ChatUnreadDot = ({ className = '' }) => {
  const { t } = useTranslation();
  return (
    <span title={t('bots.chat.unread')} aria-label={t('bots.chat.unread')} data-testid="chat-unread"
      className={`inline-block w-1.5 h-1.5 rounded-full bg-blue-400 flex-shrink-0 ${className}`} />
  );
};

export default ChatUnreadDot;
